export const rewardRoute = {
  path: "/me/reward",
  name: "me-reward",
  component: () => import("@/ui/me/reward.vue")
};